export default __webpack_public_path__ + "static/media/blm-logo-01.93162a42.svg";